import React, { Component } from "react";
import { string, number, array, func, oneOfType } from "prop-types";
//import Carousel from "../Carousel";
import Slider from "react-slick";
import axios from "axios";
import TrackVisibility from "react-on-screen";
import Slide from "./Slide";
import CustomPrevArrow from "../Components/Carousel/CustomPrevArrow.jsx";
import CustomNextArrow from "../Components/Carousel/CustomNextArrow.jsx";

class BannerSlider extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeSlide: 0,
            seenSlides: [],
            slides: [],
            loading: true
        };

        this.fetchBannerSlide = this.fetchBannerSlide.bind(this);
        this.onClick = this.onClick.bind(this);
        this.pushDataLayer = this.pushDataLayer.bind(this);
        this.onImpression = this.onImpresion.bind(this);
    }

    componentDidMount() {
        if (this.props.slides.length < 1) {
            this.fetchBannerSlide();
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (
            this.state.seenSlides.length != nextState.seenSlides.length ||
            this.state.seenSlides.length === this.state.slides.length ||
            (this.state.activeSlide != nextState.activeSlide &&
                this.state.loading)
        ) {
            return false;
        }
        return true;
    }

    fetchBannerSlide() {
        axios
            .get(`/api/banner/${this.props.sliderid}`)
            .then(bannerResult => {
                this.setState(bannerResult.data.response[0].banner);
                this.setState({ loading: false });
            })
            .catch(err => {
                console.error(err);
            });
    }

    pushDataLayer(eventType, params) {
        this.props.pushDataLayer({
            event: eventType,
            bannerName: this.state.name,
            bannerID: params.banner_ids.join(),
            slideName: params.name,
            slideID: params.id,
            advertStart: params.display_from,
            advertEnd: params.display_to,
            imgTitle: params.img_title,
            imgAlt: params.img_alt,
            clickURL: params.url,
            seller_id: params.attributes.seller_id,
            seller: params.sellerName,
            orderNumber: params.attributes.io_number,
            auction_event_id: params.attributes.auction_event_id,
            blog_id: params.attributes.blog_id,
            item_id: params.attributes.item_id,
            landing_page_id: params.attributes.landing_page_id
        });
    }

    onClick(params) {
        if (params.attributes.seller_id) {
            this.getSellerAndPushDataLayer(params.attributes.seller_id, params);
        } else {
            this.pushDataLayer("bannerSlideClick", params);
        }
    }

    getSellerAndPushDataLayer(
        sellerID,
        params,
        eventType = "bannerSlideClick"
    ) {
        axios
            .get(`/api/sellers/${sellerID}/shop`)
            .then(apiResponse => {
                params.sellerName = apiResponse.data.shop_title;
                this.pushDataLayer(eventType, params);
            })
            .catch(err => {
                console.error(err);
            });
    }

    onImpresion(slideNo) {
        const { seenSlides } = this.state;
        const currentSlide = this.state.slides[slideNo];

        this.setState({ activeSlide: slideNo }, () => {
            if (
                seenSlides.indexOf(currentSlide.id) !== -1 ||
                this.state.slides.length < 1
            )
                return;

            this.setState(
                {
                    seenSlides: [...this.state.seenSlides, currentSlide.id]
                },
                () => {
                    if (currentSlide.attributes.seller_id) {
                        this.getSellerAndPushDataLayer(
                            currentSlide.attributes.seller_id,
                            currentSlide,
                            "bannerSlideImpression"
                        );
                    } else {
                        this.pushDataLayer(
                            "bannerSlideImpression",
                            currentSlide
                        );
                    }
                }
            );
        });
    }

    render() {
        if (
            this.state.slides &&
            this.state.slides.length > 0 &&
            !this.state.loading
        ) {
            return (
                <TrackVisibility once offset={1000}>
                    {({ isVisible }) =>
                        isVisible && (
                            <Slider
                                autoplay={
                                    this.state.pause_time_between_transitions
                                        ? true
                                        : false
                                }
                                autoplaySpeed={
                                    this.state.pause_time_between_transitions
                                }
                                dots={this.state.display_bullets}
                                arrows={this.state.display_arrows}
                                infinite={true}
                                speed={this.state.slide_transition_speed}
                                slidesToShow={1}
                                slidesToScroll={1}
                                initialSlide={this.state.activeSlide}
                                beforeChange={(current, next) =>
                                    this.onImpression(next)
                                }
                                prevArrow = {<CustomPrevArrow />}
                                nextArrow = {<CustomNextArrow />}>
                                {this.state.slides.map(slide => (
                                    <Slide
                                        key={`slide-${slide.id}`}
                                        slide={slide}
                                        onClick={this.onClick}
                                        restUrl={this.props.restUrl}
                                    />
                                ))}
                            </Slider>
                        )
                    }
                </TrackVisibility>
            );
        } else {
            return null;
        }
    }
}

BannerSlider.defaultProps = {
    slides: [],
    restUrl: process.env.REST_URL
        ? process.env.REST_URL
        : localStorage.getItem("restUrl")
};

BannerSlider.propTypes = {
    sliderid: oneOfType([string, number]),
    slides: array,
    pause_time_between_transitions: number,
    slide_transition_speed: number,
    restUrl: string,
    pushDataLayer: func
};

export { BannerSlider };
